import React from 'react';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

const WidgetDeliveryAddress = (props) => {
  const { loginId } = props;
  const preText = props.childProps.state.prevMessage;
  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _qna = () => {
    const sessionKey = uuidv4();
    props.childProps.actionProvider._selectQna('1 : 1 문의하기', sessionKey);
  };
  const _address = () => {
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용이 가능합니다.');
    } else {
      window.open('https://shop.aniplustv.com/mypage/order');
    }
  };
  return (
    <>
      <div className="delivery-info">
        <div className="delivery-title">
          <h2>배송지 변경 방법</h2>
        </div>
        <div className="delivery-content">
          배송지 주소의 변경은 “배송 시작 전”에 한하여 가능합니다. <br />
          <br />
          배송 시작 이후(배송 중)에는 배송지 변경이 절대 불가한 점 유의해주시길
          바랍니다.
          <br />
          *상세 주소에는 우편번호가 아닌 동/호수를 입력해주시길 바랍니다.
          <br />
          <br />
          직접 주소 변경이 어려우시거나 사이트 이용에 문제를 겪으신 경우 변경을
          희망하시는 주소지와 구매하신 상품명을 해당 상품의 “온라인샵 1:1
          문의”로 재문의 주시면 주소지 변경을 도와드리겠습니다.
        </div>
        <div className="delivery-info-btn">
          <div className="btn-change" onClick={_address}>
            주소지 변경 하기
          </div>
          <div className="btn-qna" onClick={_qna}>
            1:1 문의 하기
          </div>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText === '' ||
          preText === undefined ||
          preText === null ? null : (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetDeliveryAddress));
